interface ScreenSizes {
  XS: number;
  MD: number;
}

export const SCREEN_SIZES: ScreenSizes = {
  XS: 710,
  MD: 1200,
} as const;
